export function getNextKeyByKey(key, obj) {
    let keys = Object.keys(obj),
        nextIndex = keys.indexOf(key) + 1;
    return keys.length > nextIndex ? keys[nextIndex] : false;
}